// @flow
import React, { Fragment } from "react";
import { Route } from "react-router-dom";
import { Empty } from "containers";
import { ConsumerReducer } from "routes";

type Props = {
    path: string,
    component: any,
    consumers?: any,
    authenticated: boolean,
    expiredToken: any,
    logout: any,
    location: any,
};

type State = {
    expired: boolean,
};

/**
 * ProtectedRoute
 * @author Tomasz tpr@deltacode.fr
 * @memberof Routes
 * @description Protected Route Component
 */
class ProtectedRoute extends React.Component<Props, State> {
    /**
     * @constructor
     * @param { Object } props Props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            expired: true,
        };
    }

    async componentDidMount() {
        /**
         * @instance
         * @async
         * @method componentDidMount
         * @memberof Routes.ProtectedRoute
         * @return { Void }
         */
        const expired = await this.props.expiredToken();
        this.setState({ expired: expired });
        if (expired) {
            await this.props.logout();
        }
    }

    render() {
        /**
         * @instance
         * @method render
         * @memberof Routes.ProtectedRoute
         * @return { String } JSX
         */
        const {
            component: RouteComponent,
            consumers,
            authenticated,
            color,
            expiredToken,
            logout,
            ...rest
        }: any = this.props;
        const { expired } = this.state;
        const Component = expired ? Empty : RouteComponent;
        return (
            <Fragment>
                {authenticated && (
                    <Route
                        render={(props) =>
                            expired ? (
                                <Route path="/" component={Component} />
                            ) : consumers ? (
                                ConsumerReducer(Component, consumers, props)
                            ) : (
                                <Component {...props} />
                            )
                        }
                        {...rest}
                    />
                )}
            </Fragment>
        );
    }
}

export { ProtectedRoute };
